import { render, staticRenderFns } from "./AddLection.vue?vue&type=template&id=d6dacdcc&"
import script from "./AddLection.vue?vue&type=script&lang=js&"
export * from "./AddLection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports